let lrc = '[00:00.00]\n' +
  '[00:03.07]化身孤岛的鲸\n' +
  '[00:06.98]原曲：谢安琪-我们都被忘了\n' +
  '[00:10.56]填词：沃特艾文\n' +
  '[00:13.59]作曲：徐浩\n' +
  '[00:16.17]编曲：徐浩\n' +
  '[00:19.60]歌手：周深卡布叻\n' +
  '[00:23.15]\n' +
  '[00:26.67]我是只化身孤岛的蓝鲸\n' +
  '[00:29.69]有着最巨大的身影\n' +
  '[00:34.11]鱼虾在身侧穿行\n' +
  '[00:38.35]也有飞鸟在背上停\n' +
  '[00:42.70]\n' +
  '[00:43.31]我路过太多太美的奇景\n' +
  '[00:46.46]如同伊甸般的仙境\n' +
  '[00:51.03]而大海太平太静\n' +
  '[00:55.19]多少故事无人倾听\n' +
  '[00:59.07]\n' +
  '[00:59.42]我爱地中海的天晴\n' +
  '[01:03.62]爱西伯利亚的雪景\n' +
  '[01:07.00]爱万丈高空的鹰\n' +
  '[01:09.14]爱肚皮下的藻荇\n' +
  '[01:12.08]我在尽心尽力地多情\n' +
  '[01:15.55]直到那一天\n' +
  '[01:18.70]\n' +
  '[01:19.12]“那一天，你来了”\n' +
  '[01:19.67]\n' +
  '[01:20.00]你的衣衫破旧\n' +
  '[01:22.04]而歌声却温柔\n' +
  '[01:24.19]陪我漫无目的四处漂流\n' +
  '[01:28.09]我的背脊如荒丘\n' +
  '[01:30.24]而你却微笑摆首\n' +
  '[01:33.05]把它当成整个宇宙\n' +
  '[01:36.32]\n' +
  '[01:36.76]你与太阳挥手\n' +
  '[01:38.95]也同海鸥问候\n' +
  '[01:41.00]陪我爱天爱地四处风流\n' +
  '[01:44.90]只是遗憾你终究\n' +
  '[01:47.09]无法躺在我胸口\n' +
  '[01:49.86]欣赏夜空最辽阔的不朽\n' +
  '[01:53.34]把星子放入眸\n' +
  '[01:58.38]\n' +
  '[02:03.30]我是只化身孤岛的蓝鲸\n' +
  '[02:06.47]有着最巨大的身影\n' +
  '[02:11.00]鱼虾在身侧穿行\n' +
  '[02:15.16]也有飞鸟在背上停\n' +
  '[02:19.52]\n' +
  '[02:20.18]我有着太冷太清的天性\n' +
  '[02:23.35]对天上的她动过情\n' +
  '[02:27.79]而云朵太远太轻\n' +
  '[02:32.02]辗转之后各安天命\n' +
  '[02:36.04]\n' +
  '[02:36.32]我未入过繁华之境\n' +
  '[02:40.51]未听过喧嚣的声音\n' +
  '[02:43.86]未见过太多生灵\n' +
  '[02:45.96]未有过滚烫心情\n' +
  '[02:48.88]所以也未觉大洋正中\n' +
  '[02:52.18]有多么安静\n' +
  '[02:55.14]\n' +
  '[02:55.65]“直到，遇见你”\n' +
  '[02:56.29]\n' +
  '[02:56.82]你的衣衫破旧\n' +
  '[02:58.85]而歌声却温柔\n' +
  '[03:01.07]陪我漫无目的四处漂流\n' +
  '[03:04.88]我的背脊如荒丘\n' +
  '[03:07.12]而你却微笑摆首\n' +
  '[03:09.90]把它当成整个宇宙\n' +
  '[03:13.11]\n' +
  '[03:13.55]你与太阳挥手\n' +
  '[03:15.79]也同海鸥问候\n' +
  '[03:17.88]陪我爱天爱地四处风流\n' +
  '[03:21.75]只是遗憾你终究\n' +
  '[03:23.87]无法躺在我胸口\n' +
  '[03:26.77]欣赏夜空最辽阔的不朽\n' +
  '[03:30.11]把星子放入眸\n' +
  '[03:34.32]\n' +
  '[03:34.61]你的指尖轻柔\n' +
  '[03:36.86]抚摸过我所有\n' +
  '[03:38.92]风浪冲撞出的丑陋疮口\n' +
  '[03:42.75]你眼中有春与秋\n' +
  '[03:45.03]胜过我见过爱过\n' +
  '[03:47.75]的一切山川与河流\n' +
  '[03:51.22]\n' +
  '[03:51.47]曾以为我肩头\n' +
  '[03:53.63]是那么的宽厚\n' +
  '[03:55.78]足够撑起海底那座琼楼\n' +
  '[03:59.65]而在你到来之后\n' +
  '[04:01.77]它显得如此清瘦\n' +
  '[04:04.68]我想给你能奔跑的岸头\n' +
  '[04:08.01]让你如同王后\n' +
  '[04:13.19]'

export default lrc



// WEBPACK FOOTER //
// ./src/assets/song-lrc.js